import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const employeeReceivableApi = factory.get("employeeReceivable");
const transferRequestApi = factory.get("transferRequest");

const initialTransfer = {
  dialog: false,
  loading: false,
  employee: null,
  item: null,
};

const initialState = {
  receivables: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 15,
      employee_id: null,
      item_id: null,
      department_id: null,
      is_active: null,
    },
    dialog: false,
    transfer: { ...initialTransfer },
  },
};

export const employeeReceivableSlice = createSlice({
  name: "employeeReceivable",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.receivables.loading = !state.receivables.loading;
    },
    setData: (state, action) => {
      state.receivables.data = action.payload.data.data;
      state.receivables.total = action.payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.receivables.filters = {
        ...state.receivables.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.receivables.filters = initialState.receivables.filters;
    },
    setFiltersDialog: (state) => {
      state.receivables.dialog = !state.receivables.dialog;
    },
    openTransfer: (state, { payload }) => {
      state.receivables.transfer = {
        ...initialTransfer,
        dialog: true,
        employee: payload.employee,
        item: payload.item,
      };
    },
    closeTransfer: (state) => {
      state.receivables.transfer = { ...initialTransfer };
    },
    setTransferLoading: (state) => {
      state.receivables.transfer.loading = !state.receivables.transfer.loading;
    },
  },
});

export const {
  setLoading,
  setData,
  setFilters,
  resetFilters,
  setFiltersDialog,
  openTransfer,
  closeTransfer,
  setTransferLoading,
} = employeeReceivableSlice.actions;

export default employeeReceivableSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().employeeReceivable.receivables.filters;
    dispatch(setLoading());
    const res = await employeeReceivableApi.index({
      page: filters.page,
      skip: filters.skip,
      take: filters.take,
      employee_id: filters.employee_id?.id,
      item_id: filters.item_id?.id,
      department_id: filters.department_id?.id,
      is_active: filters.is_active,
    });
    dispatch(setData(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Failed to fetch data",
      })
    );
    throw new Error(err);
  }
};

const transfer = (data) => async (dispatch) => {
  try {
    dispatch(setTransferLoading());
    const items = data.items.map((it) => ({
      item_id: it.item_id,
      count: Number(it.count),
      sn: it.sn || [],
      note: it.note ?? null,
    }));

    const payload = data.return_to_main
      ? {
          from_id: data.from_id,
          from_type: "User",
          return_to_main: true,
          items,
        }
      : {
          from_id: data.from_id,
          from_type: "User",
          to_id: data.to_id?.id,
          to_type: data.to_type,
          items,
          ticket_id: data.ticket_id?.id ?? null,
        };

    await transferRequestApi.create(payload);
    dispatch(setTransferLoading());
    dispatch(
      showNotification({
        type: "success",
        message: "Transfer request submitted",
      })
    );
    dispatch(closeTransfer());
    dispatch(index());
  } catch (err) {
    dispatch(setTransferLoading());
    dispatch(
      showNotification({
        type: "error",
        message:
          err.response?.data?.errors?.[0] ||
          "Failed to submit transfer request",
      })
    );
  }
};

export const EmployeeReceivable = {
  index,
  transfer,
};
